<form #workareaForm="ngForm">
    <div class="row">
        @if (projects?.length > 0) {
            <div class="col-24 col-md-8">
                <mat-form-field [floatLabel]="true" class="w-100">
                    <mat-select
                        (valueChange)="inputChanged($event)"
                        [(ngModel)]="workarea.customer_project_id"
                        [disabled]="userIsContractor"
                        name="customer_project_id"
                        placeholder="Project">
                        <mat-option [value]="undefined" disabled selected>Project</mat-option>
                        @for (project of projects; track project) {
                            <mat-option [value]="project.id">{{ project.name }}</mat-option>
                        }
                    </mat-select>
                    <mat-label>Project</mat-label>
                </mat-form-field>
            </div>
        }
        <div class="col-24 {{ projects?.length > 0 ? 'col-md-10' : 'col-md-18' }}">
            <mat-form-field [floatLabel]="true" class="w-100">
                <input
                    #street="ngModel"
                    [(ngModel)]="workarea.street"
                    [disabled]="userIsContractor"
                    errorState="street.errors?.required && (street.dirty || workareaForm.submitted)"
                    id="streetn"
                    matInput
                    name="street"
                    placeholder="Straatnaam"
                    required
                    type="text" />
                <mat-label>Straatnaam</mat-label>
            </mat-form-field>
        </div>
        <div class="col-24 col-md-6">
            <mat-form-field [floatLabel]="true" class="w-100">
                <input
                    #housenumber="ngModel"
                    [(ngModel)]="workarea.housenumber"
                    [disabled]="userIsContractor"
                    id="hnumber"
                    matInput
                    name="housenumber"
                    placeholder="Huisnummer"
                    type="text" />
                <mat-label>Huisnummer</mat-label>
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-24 col-md-6">
            <mat-form-field [floatLabel]="true" class="w-100">
                <input
                    [(ngModel)]="workarea.zipcode"
                    [disabled]="userIsContractor"
                    id="zipcode"
                    matInput
                    name="zipcode"
                    placeholder="Postcode"
                    type="text" />
                <mat-label>Postcode</mat-label>
            </mat-form-field>
        </div>
        <div class="col-24 col-md-12">
            <mat-form-field [floatLabel]="true" class="w-100">
                <input
                    #place="ngModel"
                    [(ngModel)]="workarea.place"
                    [disabled]="userIsContractor"
                    errorState="place.errors?.required && (place.dirty || workareaForm.submitted)"
                    id="customer"
                    matInput
                    name="place"
                    placeholder="Plaatsnaam"
                    required
                    type="text" />
                <mat-label>Plaatsnaam</mat-label>
            </mat-form-field>
        </div>
        <div class="col-24 col-md-6">
            <mat-form-field [floatLabel]="true" class="w-100">
                <input
                    [formControl]="roadNumberControl"
                    [disabled]="userIsContractor"
                    id="road_number"
                    matInput
                    name="road_number"
                    placeholder="Wegnummer"
                    type="text"
                    [matAutocomplete]="roadNumberAutocomplete" />
                <mat-label>Wegnummer</mat-label>
                <mat-autocomplete
                    #roadNumberAutocomplete="matAutocomplete"
                    [displayWith]="displayRoadNumberOption"
                    (optionSelected)="onRoadNumberSelected($event.option.value)">
                    @for (option of roadNumberOptions; track option) {
                        <mat-option [value]="option">
                            {{ option.label }}
                        </mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
        </div>
    </div>
</form>
